/**
 * interactive-deduction (Phase 3-3, Task 6.3) HpIndicator atom。
 *
 * Playline.deductionAttempts を視覚的に表示する小さなコンポーネント。
 * null / undefined のときは非表示 (駆け引き無効 Playline)。0 のときは使い切り状態 (disabled)。
 */

export type HpIndicatorProps = {
  /** Playline.deductionAttempts。null / undefined は駆け引き無効 Playline */
  attempts: number | null | undefined;
  /** 上限値 (UI ハート表示の満タン個数)。default 3 */
  max?: number;
};

export function HpIndicator({
  attempts,
  max = 3,
}: HpIndicatorProps): JSX.Element | null {
  if (attempts === null || attempts === undefined) return null;

  const clamped = Math.max(0, Math.min(attempts, max));
  const isDepleted = clamped === 0;

  return (
    <div
      className="inline-flex items-center gap-1"
      data-testid="hp-indicator"
      data-attempts={clamped}
    >
      <span
        className={
          isDepleted
            ? "text-red-500 font-bold"
            : "text-pink-400 font-semibold"
        }
        aria-label={`残り HP ${clamped} / ${max}`}
      >
        {Array.from({ length: max }).map((_, i) => (
          <span key={i} aria-hidden>
            {i < clamped ? "♥" : "♡"}
          </span>
        ))}
      </span>
      <span className="text-xs text-slate-400" data-testid="hp-numeric">
        {clamped} / {max}
      </span>
    </div>
  );
}
